import { I18n } from "i18n-js";
import translations from "./translations.json";

export const i18nTranslations = () => {
  const i18n = new I18n(translations);
  i18n.defaultLocale = "fr";
  i18n.locale = "fr";
  return i18n;
};
